import { useTranslation } from "react-i18next";
import { LocalizedLink } from "@/i18n/language";
import { img } from "@/lib/images";

export default function MoreThanStay() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="relative rounded-lg overflow-hidden h-[340px] md:h-[580px]">
            <img
              src={img("home/home-pavillon_01.jpg")}
              alt={t("pavillon_img_alt")}
              title={t("pavillon_img_title")}
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="eyebrow-brand text-sm md:text-base uppercase tracking-[0.35em] mb-3">— {t("home_story_eyebrow")} —</div>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-[1.1] tracking-tight mb-6">
            {t("home_story_title")}
          </h2>
          <p className="text-foreground-700 leading-relaxed text-base md:text-lg">
            {t("home_story_text")}
          </p>
          <p className="mt-4 text-foreground-700 leading-relaxed text-base md:text-lg whitespace-pre-line">
            {t("home_story_text2")}
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <LocalizedLink
              to="/activities"
              className="inline-flex items-center gap-2 bg-background-50 border border-background-500 hover:border-primary-500 hover:bg-primary-600/20 text-foreground-950 px-7 py-3.5 rounded-md font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              {t("home_story_cta")}
              <i className="ri-arrow-right-line"></i>
            </LocalizedLink>
            <LocalizedLink
              to="/villas"
              className="inline-flex items-center gap-2 bg-background-50 border border-background-500 hover:border-primary-500 hover:bg-primary-600/20 text-foreground-950 px-7 py-3.5 rounded-md font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              {t("home_story_cta2")}
              <i className="ri-home-4-line"></i>
            </LocalizedLink>
          </div>
        </div>
      </div>
    </section>
  );
}